// Skiparene i et skiplukk: ett kort per par (f.eks. kunden og kona), med bruk, nivå, vekt,
// høyde, ønsket lengde og budsjett. Brukes i CreateOrder og OrderDetails.
import React from 'react';
import { Tekstfelt, Valgknapper, knappSekundar } from '../ny-kundesamhandling/Skjema';
import Ikon from '../ny-kundesamhandling/Ikon';
import { BRUK, NIVA, MAKS_PAR, tomtPar } from './felles';

// kundeNavn: forslag til «Hvem er skiene til?» (knapp under tomme felt).
export default function ParSkjema({ idPrefiks, par, onEndre, kundeNavn = '' }) {
  const sett = (i, felt, verdi) => onEndre(par.map((p, j) => (j === i ? { ...p, [felt]: verdi } : p)));
  const fjern = (i) => onEndre(par.filter((_, j) => j !== i));

  return (
    <div className="space-y-3">
      {par.map((p, i) => {
        const id = `${idPrefiks}-par${i}`;
        return (
          <fieldset key={i} className="min-w-0 space-y-3 rounded-2xl border-2 border-teal-200 bg-white p-3">
            <legend className="px-1 text-base font-bold text-slate-900">
              {par.length > 1 ? `Par ${i + 1}` : 'Skiene'}
              {p.hvem && <span className="font-normal text-slate-700"> – {p.hvem}</span>}
            </legend>
            <div>
              <Tekstfelt
                id={`${id}-hvem`}
                etikett="Hvem er skiene til?"
                hjelp="Kundens navn, eller f.eks. «kona» eller et annet navn."
                value={p.hvem}
                onChange={(e) => sett(i, 'hvem', e.target.value)}
                maxLength={60}
              />
              {kundeNavn && !p.hvem.trim() && (
                <button
                  type="button"
                  onClick={() => sett(i, 'hvem', kundeNavn.slice(0, 60))}
                  className="mt-2 inline-flex min-h-[2.25rem] items-center gap-2 rounded-xl border-2 border-sky-300 bg-sky-50 px-3 py-1.5 text-sm font-semibold text-sky-900 hover:bg-sky-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-600/50"
                >
                  <Ikon navn="person" className="w-4 h-4" /> Bruk kundens navn ({kundeNavn})
                </button>
              )}
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              <Tekstfelt id={`${id}-merke`} etikett="Merke" hjelp="F.eks. Madshus, Fischer, Atomic." value={p.merke} onChange={(e) => sett(i, 'merke', e.target.value)} maxLength={60} required />
              <Tekstfelt id={`${id}-produkt`} etikett="Produkt" hjelp="Valgfritt, modell kunden ønsker." value={p.produkt} onChange={(e) => sett(i, 'produkt', e.target.value)} maxLength={80} />
            </div>
            <Valgknapper id={`${id}-bruk`} etikett="Bruk" valg={BRUK} verdi={p.bruk} onVelg={(v) => sett(i, 'bruk', v)} />
            <Valgknapper id={`${id}-niva`} etikett="Nivå" valg={NIVA} verdi={p.niva} onVelg={(v) => sett(i, 'niva', v)} />
            <div className="grid gap-3 sm:grid-cols-2">
              <Tekstfelt id={`${id}-vekt`} etikett="Vekt (kg)" hjelp="Trengs for riktig spenn." inputMode="numeric" value={p.vekt} onChange={(e) => sett(i, 'vekt', e.target.value)} maxLength={5} required />
              <Tekstfelt id={`${id}-hoyde`} etikett="Høyde (cm)" hjelp="Trengs for riktig lengde." inputMode="numeric" value={p.hoyde} onChange={(e) => sett(i, 'hoyde', e.target.value)} maxLength={5} required />
              <Tekstfelt id={`${id}-lengde`} etikett="Ønsket lengde" hjelp="Valgfritt, f.eks. «200–205»." value={p.lengde} onChange={(e) => sett(i, 'lengde', e.target.value)} maxLength={60} />
              <Tekstfelt id={`${id}-budsjett`} etikett="Budsjett" hjelp="Valgfritt, f.eks. «inntil 4000»." value={p.budsjett} onChange={(e) => sett(i, 'budsjett', e.target.value)} maxLength={60} />
            </div>
            <label className="flex min-h-[2.25rem] cursor-pointer items-start gap-2 rounded-xl border-2 border-slate-200 bg-slate-50 px-3 py-1.5">
              <input
                type="checkbox"
                checked={Boolean(p.grunnprepp)}
                onChange={(e) => sett(i, 'grunnprepp', e.target.checked)}
                aria-describedby={`${id}-grunnprepp-hjelp`}
                className="mt-1 h-5 w-5 shrink-0"
              />
              <span>
                <span className="block font-semibold text-slate-900">Kunden ønsker grunnprepp</span>
                <span id={`${id}-grunnprepp-hjelp`} className="block text-sm text-slate-600">
                  «Grunnprepp nye ski» blir valgt når skiplukket gjøres om til service.
                </span>
              </span>
            </label>
            {par.length > 1 && (
              <button type="button" onClick={() => fjern(i)} className={`${knappSekundar} text-red-800`}>
                Fjern par {i + 1}
              </button>
            )}
          </fieldset>
        );
      })}
      {par.length < MAKS_PAR && (
        <button type="button" onClick={() => onEndre([...par, tomtPar()])} className={knappSekundar}>
          <Ikon navn="pluss" className="w-5 h-5" /> Legg til et par til
        </button>
      )}
    </div>
  );
}
